import { css } from "aphrodite";
import React from "react";
import { ContentCard, ContentRow } from "../../common";
import { PERMISSION_TYPES } from "../../../library/constants";
import styles from "./users-listing-styles";
const UsersListingView = props => (
  <ContentCard title={"Users & Permissions"} {...props}>
    {props.data &&
      props.data.map((item, index) => {
        let finalPermissionText = "";
        PERMISSION_TYPES.forEach(permissionItem => {
          if (item[permissionItem.key]) {
            finalPermissionText =
              finalPermissionText + ` ${permissionItem.value},`;
          }
        });
        if (finalPermissionText)
          finalPermissionText = finalPermissionText.substring(
            0,
            finalPermissionText.length - 1
          );
        return (
          <ContentRow key={index}>
            <div>{item.email}</div>
            <div style={{ flex: 1 }} />
            <div className={css(styles.permissionTags)}>
              {finalPermissionText}
            </div>
          </ContentRow>
        );
      })}
  </ContentCard>
);

export default UsersListingView;



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-listing/users-listing-view.js